<template>
  <div v-if="isOpen">
    <div class="modal fade" role="dialog" ref="vue_modal_complete_trip">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header modal-complete-trip">
            <div class="row">
              <div class="col-sm-10">
                <h4>{{ data.code }}</h4>
                <span>Last State: {{ data.lastState }}</span>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="onCloseModal()"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <!-- Start: Content -->
            <div class="modal-container">
              <div class="complete-trip-wrapper">
                <h4>Passenger Details</h4>
                <div class="pax-name">{{ data.customerName }}</div>
                <div class="service-type">
                  <ul>
                    <li v-if="data.serviceType === 'AirportTransfer'">
                      <i class="ic-flight-icon"></i>Airport Transfer
                    </li>
                    <li v-else><i class="ic-time"></i>Hourly Booking</li>
                  </ul>
                </div>
                <div class="reservation-location">
                  <div class="pickup-wrapper">
                    <div class="area">
                      <span>Pick Up Area</span>
                      <div class="location">
                        {{ data.pickUpLocation }}
                      </div>
                    </div>
                    <div class="date-time">
                      <div class="rent-date">
                        <i class="ic-date-picker"></i>
                        {{ data.pickUpDate.stringDate }}
                        {{ data.pickUpDate.stringShortMonth }}
                      </div>
                      <div class="rent-time">
                        <i class="ic-time"></i>
                        {{ data.pickUpDate.stringHour }}.{{
                          data.pickUpDate.stringMinute
                        }}
                        <span class="utc-zone">{{
                          data.pickUpDate.offsetName
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="dropoff-wrapper text-right">
                    <div class="area">
                      <span>Drop Off Area</span>
                      <div class="location">{{ data.dropOffLocation }}</div>
                    </div>
                    <div class="date-time">
                      <div class="rent-date">
                        {{ data.dropOffDate.stringDate }}
                        {{ data.dropOffDate.stringShortMonth }}
                        <i class="ic-date-picker"></i>
                      </div>
                      <div class="rent-time">
                        {{ data.dropOffDate.stringHour }}.{{
                          data.dropOffDate.stringMinute
                        }}
                        <span class="utc-zone">{{
                          data.dropOffDate.offsetName
                        }}</span>
                        <i class="ic-time"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="complete-trip-wrapper">
                <div class="warning-alert-upload mt-20">
                  <div class="img-warning">
                    <img
                      src="/static/assets/images/warning.svg"
                      alt="warning-images"
                      width="20"
                      height="20"
                    />
                  </div>
                  <span
                    >You'll need to upload a photo of the receipt and enter the
                    cost of any extra services before you mark the trip as
                    completed.</span
                  >
                </div>
              </div>
              <div class="complete-trip-wrapper">
                <h4 class="mt-20">Post-Booking Extras</h4>

                <div id="form-contact" style="margin-top: 0">
                  <form @submit.prevent="submit">
                    <div class="row d-flex justify-start items-center">
                      <div class="col-sm-4">
                        <label class="cursor-pointer">
                          <input
                            type="checkbox"
                            class="control-checkbox"
                            v-model="model[0].active"
                          />
                          <span
                            class="pl-5 font-weight-normal v-align-middle text-filter"
                          >
                            Parking
                          </span>
                        </label>
                      </div>
                      <div class="col-sm-4" v-if="model[0].active">
                        <v-select
                          class="v-search-select"
                          placeholder="Currency"
                          label="label"
                          v-model="model[0].currency"
                          :options="currencyOptions"
                          :clearable="false"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.value"
                        ></v-select>
                      </div>
                      <div class="col-sm-4" v-if="model[0].active">
                        <div>
                          <currency-input
                            class="form-control"
                            autocomplete="off"
                            placeholder="Enter rate"
                            v-model="model[0].rate"
                            :allow-negative="true"
                            :currency="null"
                            :locale="moneyFormat.cultureCode"
                            :precision="moneyFormat.numberOfDecimal"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mt-10"
                      v-if="model[0].active && model[0].imagePreview"
                    >
                      <div class="col-sm-12">
                        <div v-if="model[0].imagePreview" class="img__box">
                          <img
                            :src="model[0].imagePreview"
                            alt="post-booking-post-image"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-10" v-if="model[0].active">
                      <div class="col-sm-12">
                        <div class="btn-upload-wrapper">
                          <button class="btn btn-upload">
                            <i class="ic-up"></i>
                            Parking Photos
                          </button>
                          <input
                            id="image-uploader"
                            type="file"
                            name="imageData"
                            accept="image/jpeg,image/png"
                            v-on:change="
                              onChangeImage($event.target.files, 'parking')
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row d-flex justify-start items-center mt-10">
                      <div class="col-sm-4">
                        <label class="cursor-pointer">
                          <input
                            type="checkbox"
                            class="control-checkbox"
                            v-model="model[1].active"
                          />
                          <span
                            class="pl-5 font-weight-normal v-align-middle text-filter"
                          >
                            Road Toll
                          </span>
                        </label>
                      </div>
                      <div class="col-sm-4" v-if="model[1].active">
                        <v-select
                          class="v-search-select"
                          placeholder="Currency"
                          label="label"
                          v-model="model[1].currency"
                          :options="currencyOptions"
                          :clearable="false"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.value"
                        ></v-select>
                      </div>
                      <div class="col-sm-4" v-if="model[1].active">
                        <div>
                          <currency-input
                            class="form-control"
                            autocomplete="off"
                            placeholder="Enter rate"
                            v-model="model[1].rate"
                            :allow-negative="true"
                            :currency="null"
                            :locale="moneyFormat.cultureCode"
                            :precision="moneyFormat.numberOfDecimal"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="row mt-10"
                      v-if="model[1].active && model[1].imagePreview"
                    >
                      <div class="col-sm-12">
                        <div v-if="model[1].imagePreview" class="img__box">
                          <img
                            :src="model[1].imagePreview"
                            alt="post-booking-post-image"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mt-10" v-if="model[1].active">
                      <div class="col-sm-12">
                        <div class="btn-upload-wrapper">
                          <button class="btn btn-upload">
                            <i class="ic-up"></i>
                            Toll Fare Photos
                          </button>
                          <input
                            id="image-uploader"
                            type="file"
                            name="imageData"
                            accept="image/jpeg,image/png"
                            v-on:change="
                              onChangeImage($event.target.files, 'toll')
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      :disabled="disabledBtnComplete"
                      class="btn btn-complete-job"
                    >
                      Complete
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <!-- End: Content -->
          </div>
        </div>
      </div>
    </div>

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import inquiryTenantJobService from "@/services/job/tenantJob/inquiryTenantJobService.js";
import { firebaseDB } from "@/plugins/firebase.js";

export default {
  data() {
    return {
      data: null,
      moneyFormat: null,
      isOpen: false,
      isLoading: false,
      msg: "Please wait",
      currencyOptions: [],
      model: [
        {
          fareComponentType: "FareParking",
          qty: 1,
          currency: null,
          rate: null,
          attachment: null,
          imagePreview: null,
          active: false,
        },
        {
          fareComponentType: "FareToll",
          qty: 1,
          currency: null,
          rate: null,
          attachment: null,
          imagePreview: null,
          active: false,
        },
      ],
    };
  },
  computed: {
    disabledBtnComplete() {
      if (this.model[0].active && this.model[1].active) {
        return !this.model[0].rate && !this.model[1].rate;
      } else if (this.model[0].active) {
        return !this.model[0].rate;
      } else if (this.model[1].active) {
        return !this.model[0].rate;
      } else {
        return false;
      }
    },
  },
  created() {
    this.$eventBus.$on("completeTrip", this.initialize);
  },
  beforeDestroy() {
    this.$eventBus.$off("completeTrip");
  },
  methods: {
    initialize(data, currency, moneyFormat) {
      this.isLoading = true;
      this.isOpen = true;
      this.data = data;
      this.moneyFormat = moneyFormat;
      this.currencyOptions = currency.map((val) => ({
        label: val,
        value: val,
      }));
      this.model[0].currency = currency[0];
      this.model[1].currency = currency[0];
      setTimeout(() => {
        $(this.$refs.vue_modal_complete_trip).modal({
          backdrop: "static",
          keyboard: false,
        });
        this.isLoading = false;
      }, 1000);
    },
    onCloseModal() {
      this.data = null;
      this.currencyOptions = [];
      this.model = [
        {
          fareComponentType: "FareParking",
          qty: 1,
          currency: null,
          rate: null,
          attachment: null,
          imagePreview: null,
          active: false,
        },
        {
          fareComponentType: "FareToll",
          qty: 1,
          currency: null,
          rate: null,
          attachment: null,
          imagePreview: null,
          active: false,
        },
      ];
      this.isOpen = false;
      $(this.$refs.vue_modal_complete_trip).modal("hide");
    },
    onChangeImage(files, key) {
      const maxSize = 4 * 1024 * 1024;
      if (files[0].size > maxSize) {
        this.model[0].imagePreview = null;
        this.model[1].imagePreview = null;
        this.model[0].attachment = null;
        this.model[1].attachment = null;
        document.getElementById("image-uploader").value = "";
        alert(
          `File is too big, max-size is  ${parseInt(maxSize / 1000000)}MB.`
        );
        return;
      }
      if (
        !["jpeg", "jpg", "png"].includes(
          files[0].name
            .substring(files[0].name.lastIndexOf(".") + 1)
            .toLowerCase()
        )
      ) {
        this.model[0].imagePreview = null;
        this.model[1].imagePreview = null;
        this.model[0].attachment = null;
        this.model[1].attachment = null;
        document.getElementById("image-uploader").value = "";
        alert("Invalid file type.");
        return;
      }

      if (key === "parking") {
        this.model[0].imagePreview = URL.createObjectURL(files[0]);
        this.model[0].attachment = files[0];
      } else {
        this.model[1].imagePreview = URL.createObjectURL(files[0]);
        this.model[1].attachment = files[0];
      }
    },
    async submit() {
      this.loading = true;
      try {
        const formData = new FormData();

        const filterData = this.model.filter((val) => val.active === true);

        if (filterData.length) {
          filterData.forEach(async (val, index) => {
            for (const key in val) {
              formData.append(
                "postBookingExtras" + `[${index}].` + key,
                val[key]
              );
            }
          });
        }

        const response = await inquiryTenantJobService.submitCompleteTrip(
          this.data.reservationId,
          formData
        );

        if (response.isSuccess) {
          this.deleteReservationOnFirebase(this.data.reservationId);
          this.$notification.success("Job succesfully marked as completed.", {
            title: "Success",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
        this.onCloseModal();
        this.$emit("finish", "run");
      }
    },
    deleteReservationOnFirebase(reservationId) {
      firebaseDB.ref("locations/" + reservationId).remove();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/CompleteTrip.vue